import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { BehaviorSubject, catchError, map, Observable, of } from 'rxjs';
import { API_ROUTES } from '../../_constants/api-route.constant';
import { LocalStorageProvider } from '../common/storage.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  adminEmail:any;
  private loggedIn = new BehaviorSubject<boolean>(false);

  constructor(private Http:HttpClient,
      private storageService: LocalStorageProvider,
      private router: Router,
      private loader: NgxUiLoaderService
    ) { }

  login(body:Object): Observable<any> {
    return this.Http.post<any>(`${API_ROUTES.ACCOUNT.login}`,body);
  }
  // test(){
  //   return this.Http.get("http://3.16.252.222:3000/v1/superAdmin/viewProfile").pipe(map(response => {
  //      return response;
  //   }),
  //   catchError(err => {
	// 		return of({error:{message:err}});
	// 	  })
  //   );
  // }
  get isLoggedIn() {
    let token = this.storageService.getItem('token')
    if (token != undefined && token != null) {
      this.loggedIn.next(true);
    }
    return this.loggedIn.asObservable();
  }
  // email(data:any){
  //   if(data){
  //     this.adminEmail.next(data);
  //   }
  //   return this.adminEmail.asObservable();
  // }
  logout() {
    this.loader.start();
    this.storageService.clearAll();
    this.loggedIn.next(false);
    this.loader.stop();
    this.router.navigate(['']);
  }
}
